import { render } from "./multiple_category.vue?vue&type=template&id=5cfa58db"
import script from "./multiple_category.vue?vue&type=script&lang=js"
export * from "./multiple_category.vue?vue&type=script&lang=js"

import "./multiple_category.vue?vue&type=style&index=0&id=5cfa58db&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__